import React, { useState, useEffect } from "react";
import { string, object, array } from "prop-types";
import { Link, SocialShare } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import ScrollSnap from "../../atoms/ScrollSnap";
import RightArrowButton from "../../atoms/icons/right-arrow-button";
import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import SocialShareTemplate from "../../molecules/SocialShareTemplate";
import StoryMetaData from "../../molecules/StoryMetaData";
import Organism1 from "../BigPhotoStoryCardSlider1Ad/Organism1";
import DfpAd from "../../dfp-ad";
import { getSlug } from "../../utils/utils";

import "./bigPhotoStoryCardSlider1Ad.m.css";

const BigPhotoStoryCardSlider1Ad = ({ collection, className = "", sections, publisherAttributes, domainSlug }) => {
  const stories =
    collection.items.length > 0 && collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (!stories.length) {
    return null;
  }

  const showStoriesWithAd = get(collection, ["associated-metadata", "show_stories_Ad"], true);
  const firstStory = stories[0];
  const remainingStories = stories.slice(1, stories.length);

  const [photoElements, setPhotoElements] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isTabDesktop, setIsTabDesktop] = useState(false);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const storyHeadlineStyle = `${publisherAttributes.lang}-first-story-headline`;
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  const adSlotId1 = get(collection, ["associated-metadata", "ad_slot_id1"], "default_ad_slot1");
  const adSlotId2 = get(collection, ["associated-metadata", "ad_slot_id2"], "default_ad_slot2");

  useEffect(() => {
    setIsDesktop(global.deviceWidth > 1263);
    setIsTabDesktop(global.deviceWidth > 875);
    processPhotoElements();
  }, []);

  function processPhotoElements() {
    const children = [];

    if (firstStory.cards && firstStory.cards.length) {
      firstStory.cards.forEach((card) => {
        const imageList = card["story-elements"].filter((element) => element.type === "image");
        if (imageList && imageList.length) {
          imageList.forEach((item) => {
            const storyCardObj = {
              "hero-image-s3-key": item["image-s3-key"],
              "hero-image-metadata": item["image-metadata"],
              "hero-image-caption": item.title,
            };

            children.push(
              <div key={item.id}>
                <Link href={firstStory.url}>
                  <CardImage
                    story={storyCardObj}
                    key={item.id}
                    aspectRatio={[16, 9]}
                    imageType="image16x9"
                    widths={[1000]}
                    showAlternateImage={true}
                  />
                </Link>
              </div>
            );
          });
        }
      });
    }
    setPhotoElements(children);
  }

  function textDataRender(firstStory) {
    return (
      <div styleName="text-wrapper">
        <Link href={firstStory.url}>
          <Headline
            headerLevel={2}
            headlineType={35}
            text={firstStory.headline}
            className="story-headline"
            styleName={storyHeadlineStyle}
          />
        </Link>
        <StoryMetaData story={firstStory} isAuthor={false} />
        {firstStory.subheadline && (
          <Headline
            text={firstStory.subheadline}
            headlineType={6}
            className="story-subheadline"
            styleName={subHeadlineStyle}
          />
        )}
        <div styleName="icon-wrapper">
          <SocialShare template={SocialShareTemplate} title={firstStory.headline} fullUrl={encodeURI(firstStory.url)} />
        </div>
      </div>
    );
  }

  if (!photoElements) {
    return null;
  }

  return (
    <div styleName={`base ${publisherAttributes.lang}-base`} className={className}>
      <div styleName="wrapper">
        <div styleName="image-wrapper">
          {photoElements && photoElements.length ? (
            <ScrollSnap
              leftArrow={<LeftArrowButton />}
              rightArrow={<RightArrowButton />}
              isIndicator={false}
              displaySliderCount={isTabDesktop && photoElements.length > 1 && true}
              lang={publisherAttributes.lang}
            >
              {photoElements}
            </ScrollSnap>
          ) : (
            <Link href={firstStory.url}>
              <CardImage
                story={firstStory}
                aspectRatio={[16, 9]}
                imageType="image16x9"
                widths={[1000]}
                showAlternateImage={true}
              />
            </Link>
          )}
          {!isDesktop && textDataRender(firstStory)}
        </div>

        <div styleName="content-wrapper">
          {isDesktop && textDataRender(firstStory)}
          <div styleName="side-ad">
            <DfpAd
              adtype="News_336x280_R1"
              collectionSlug={collectionSlug}
              layoutName="BigPhotoStoryCardSlider1Ad"
              slotId={adSlotId1}
            />
          </div>
        </div>
      </div>

      {showStoriesWithAd && (
        <Organism1 stories={remainingStories} collectionSlug={collectionSlug} adSlotId={adSlotId2} />
      )}
    </div>
  );
};

BigPhotoStoryCardSlider1Ad.propTypes = {
  className: string,
  firstStory: object,
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(BigPhotoStoryCardSlider1Ad);
